// @ts-nocheck
import update from 'immutability-helper'
import { AddDomainApiErrors } from '@feedyou/utils'

import * as actionTypes from '../constants/actionTypes'

const initialState = {
  loading: undefined,
  error: undefined,
  domains: undefined
}

export function domainsReducer(state = initialState, { type, payload }) {
  switch (type) {
    case actionTypes.GET_DOMAINS:
      return { ...state, loading: true, error: undefined }

    case actionTypes.GET_DOMAINS_SUCCESS:
      return {
        ...state,
        domains: payload.reduce((domains, domain) => {
          domain.id = domain.domain
          domains[domain.id] = domain

          return domains
        }, {}),
        loading: undefined
      }

    case actionTypes.GET_DOMAINS_FAILURE:
      return { ...state, error: AddDomainApiErrors.GetDomainsFailure, loading: undefined }

    case actionTypes.ADD_DOMAIN_PLACEHOLDER:
      return { ...state, placeholder: {} }

    case actionTypes.ADD_DOMAIN:
      return update(state, { placeholder: { loading: { $set: true }, error: { $set: undefined } } })

    case actionTypes.ADD_DOMAIN_SUCCESS:
      payload.id = payload.domain

      return update(state, {
        $unset: ['placeholder'],
        domains: { [payload.id]: { $set: payload } }
      })

    case actionTypes.ADD_DOMAIN_FAILURE:
      return update(state, {
        placeholder: {
          loading: { $set: undefined },
          error: { $set: payload || AddDomainApiErrors.AddDomainFailure }
        }
      })

    case actionTypes.UPDATE_DOMAIN:
      return update(state, {
        domains: { [payload.id]: { $merge: { ...payload, error: undefined } } }
      })

    case actionTypes.UPDATE_DOMAIN_FAILURE:
      return update(state, {
        domains: { [payload]: { error: { $set: AddDomainApiErrors.UpdateDomainFailure } } }
      })

    case actionTypes.DELETE_DOMAIN:
      return update(state, {
        domains: { [payload]: { deleting: { $set: true }, error: { $set: undefined } } }
      })

    case actionTypes.DELETE_DOMAIN_SUCCESS:
      return update(state, {
        domains: { $unset: [payload] }
      })

    case actionTypes.DELETE_DOMAIN_FAILURE:
      return update(state, {
        domains: {
          [payload]: {
            deleting: { set: undefined },
            error: { $set: AddDomainApiErrors.DeleteDomainFailure }
          }
        }
      })

    default:
      return state
  }
}
